import { fetchCourses } from "PlatForms/OrgLMS/Services/MentorServices/LibraryService";
import { useEffect, useState } from "react";

export const useLibrary = () => {
  const mentorId = localStorage.getItem("personalId");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCourses();
  }, []);

  const getCourses = async () => {
    try {
      setLoading(true);
      const data = await fetchCourses(mentorId);
      setCourses(data);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    courses,
    loading,
  };
};
